import React from 'react';
import { Container } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { InfoMessage, LoadingStatusWrapper, PopOutChart } from 'sharedComponents';
import { apiCallStatus } from 'helpers/constants';
import { histogramContainerId } from './constants';
import useChartConfig, { chartPlugins } from './useChartConfig';
import { EmptyComparisonMessage } from '../EmptyComparisonMessage';

import '../style.scss';

const HistogramComponent = ({
    chartData,
    removeKPIData,
    chartLoadingStatus,
    chartErrorData,
    isZoomed,
    setIsZoomed,
    isComparisonView,
    offGraphSignalsCount
}) => {
    const chartOptions = useChartConfig(chartData, removeKPIData);

    const renderNoKpiContent = () => {
        if (chartErrorData?.loadingStatus === apiCallStatus.ERROR) {
            return <InfoMessage
                title='ABB.Powertrain.Frontend.errorBoundaryMessageTitle500'
                text='ABB.Powertrain.Frontend.errorBoundaryMessageDesc500' />;
        }
        if (isComparisonView) {
            return <EmptyComparisonMessage offGraphSignalsCount={offGraphSignalsCount} />;
        }
        return <InfoMessage
            title='ABB.Powertrain.Frontend.chartNoKPIsSelected'
            text='ABB.Powertrain.Frontend.chartNoKPIsSelectedUserGuide' />;
    };

    return (
        <Container fluid className='cross-asset-chart-container'>
            <LoadingStatusWrapper
                useCustomAnchor
                transparent
                loadingStatus={chartLoadingStatus}>
                <PopOutChart
                    hasKpi={!!chartData?.length}
                    hasData={!!chartData?.length}
                    renderNoKpi={renderNoKpiContent}
                    renderNoData={() => <InfoMessage
                        title='ABB.Powertrain.Frontend.noDataLabelAvailable'
                        text='ABB.Powertrain.Frontend.adjustDateRangeOrChartType' />}
                    loadingStatus={chartLoadingStatus}
                    options={chartOptions}
                    modules={chartPlugins}
                    container={histogramContainerId}
                    isZoomed={isZoomed}
                    setIsZoomed={setIsZoomed}
                    hideDownloadButton={true}
                    isNotPreserveSignals={true}
                />
            </LoadingStatusWrapper></Container>
    );
};

export default HistogramComponent;
HistogramComponent.propTypes = {
    chartData: PropTypes.shape({
        length: PropTypes.number,
    }),
    removeKPIData: PropTypes.func,
    chartLoadingStatus: PropTypes.string,
    chartErrorData: PropTypes.object,
    isZoomed: PropTypes.bool,
    setIsZoomed: PropTypes.func,
    isComparisonView: PropTypes.bool,
    offGraphSignalsCount: PropTypes.number
};
